import { render, staticRenderFns } from "./RequestMaterials.vue?vue&type=template&id=1f1518ea&scoped=true&"
import script from "./RequestMaterials.vue?vue&type=script&lang=js&"
export * from "./RequestMaterials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1518ea",
  null
  
)

export default component.exports